import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Check, ArrowRight } from "lucide-react";

const PageHero = ({ eyebrow, title, subtitle, image }) => (
  <section className="relative pt-32 pb-16 overflow-hidden">
    <div className="blob-pink absolute -top-20 -right-20 opacity-60" />
    <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand mb-3">{eyebrow}</p>
        <h1 className="font-heading text-5xl md:text-6xl font-black tracking-tighter text-navy-900 text-balance">{title}</h1>
        <p className="mt-6 text-lg text-slate-600 max-w-xl">{subtitle}</p>
        <div className="mt-8 flex gap-4">
          <Link to="/contact" className="btn-pink">Gratis advies <ArrowRight size={18} /></Link>
          <Link to="/#calculator" className="btn-ghost">Bereken besparing</Link>
        </div>
      </motion.div>
      {image && (
        <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.7, delay: 0.15 }} className="relative aspect-[4/3] rounded-3xl overflow-hidden shadow-[0_30px_80px_rgba(15,23,42,0.18)]">
          <img src={image} alt={title} className="w-full h-full object-cover" />
        </motion.div>
      )}
    </div>
  </section>
);

const FeatureList = ({ items, title }) => (
  <section className="section-pad bg-slate-50/70">
    <div className="max-w-5xl mx-auto px-5 lg:px-8">
      <h2 className="font-heading text-4xl font-black tracking-tighter text-navy-900 mb-10 text-balance">{title}</h2>
      <div className="grid md:grid-cols-2 gap-5">
        {items.map((it, i) => (
          <div key={i} className="flex items-start gap-4 bg-white rounded-2xl border border-slate-200 p-6">
            <span className="w-8 h-8 rounded-full bg-brand-soft text-brand flex items-center justify-center flex-shrink-0">
              <Check size={16} strokeWidth={3} />
            </span>
            <div>
              <h3 className="font-heading font-bold text-navy-900 mb-1">{it.title}</h3>
              <p className="text-slate-600 text-sm">{it.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export { PageHero, FeatureList };
